<template>
  <div class="grid-container">
    <form :class="{'opacity-50': isWorking}" @submit.prevent="submit">
      <section-header size="xl" variants="dividing" class="mt-3">
        <heading level="1" size="xl" v-html="bp('profile.update.languagePreference')"></heading>
      </section-header>
      <callout v-if="message" :icon="messageIcon" :type="messageType">{{ message }}</callout>
      <div class="max-w-sm mb-6">
        <form-group
          v-if="hasData"
          v-model="preferredLanguage"
          name="language"
          type="select"
          :label="bp('countryselector.language')"
          :multi-items="countryData"
        />
        <div class="buttons">
          <trek-button primary type="submit" qaid="language-save-btn" :disabled="isWorking" @click="submit">
            <span v-html="bp('text.button.save')"></span>
          </trek-button>
          <trek-button secondary qaid="language-cancel-btn" @click="cancel">
            <span v-html="bp('text.account.profile.cancel')"></span>
          </trek-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import get from 'lodash/get';
import Heading from '@/components/Heading';
import Callout from '@/components/Callout';
import FormGroup from '@/components/FormGroup';
import TrekButton from '@/components/TrekButton';
import SectionHeader from '@/components/SectionHeader';
import {UserAccountBase} from '@/components/containers/my-account/utils/user-account-base';

export default {
  name: 'EditLanguageContainer',
  components: {Heading, Callout, FormGroup, TrekButton, SectionHeader},
  extends: UserAccountBase,
  props: {
    customerPreferredLanguage: {
      type: String,
      required: false,
      default: 'en',
    },
  },
  data() {
    return {
      countryData: {},
      preferredLanguage: '',
    };
  },
  computed: {
    hasData() {
      return Object.keys(this.countryData).length > 0;
    },
  },
  async created() {
    try {
      this.isWorking = true;
      const response = await this.api.retrieveAvailableLanguages();
      this.countryData = this.getCountryData(get(response, 'data.data'));
      this.preferredLanguage = this.customerPreferredLanguage;

      if (!this.preferredLanguage && this.hasData) {
        this.preferredLanguage = this.countryData[0].isocode;
      }
    } finally {
      this.isWorking = false;
    }
  },
  methods: {
    async processUpdate() {
      try {
        this.isWorking = true;
        const response = await this.api.updateLanguage(this.preferredLanguage);
        this.displaySuccess(get(response.data, 'meta.feedback.message.basePropertyValue'));
      } catch (e) {
        this.displayError(get(e.response.data, 'meta.feedback.message.basePropertyValue'));
      } finally {
        this.isWorking = false;
      }
    },

    /**
     * Prepare country data in format needed by select.
     * @param data
     * @return {[]}
     */
    getCountryData(data) {
      let countryData = [];
      if (!data || !data.length) {
        return countryData;
      }

      data.forEach((item) => {
        countryData.push({
          value: item.isocode,
          displayName: item.name,
        });
      });

      return countryData;
    },
  },
};
</script>
